<template>
  <div>
    復元を実行すると、同時に凍結されていた全てのIDが復元されます。<br />
    生徒IDが含まれている場合、復元すると課金対象としてカウントされ ます。<br />
    <label class="objects-header">復元されるID数：{{ totalRelatedFrozens }}</label>
    <b-table
      ref="related-table"
      class="sticky-table"
      responsive
      sticky-header
      :items="frozen.relatedFrozens"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:head()="scope">
        <div class="text-nowrap">
          <b>{{ scope.label }}</b>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { basicFrozenType } from '@/presenters/fields';

export default {
  data() {
    return {
      fields: [
        {
          key: 'type',
          label: 'ID種別',
          sortByFormatted: true,
          filterByFormatted: true,
          formatter: (value) => {
            return this.frozenTypeDisplay(value);
          },
        },
        {
          key: 'frozenName',
          label: '名前',
          formatter: (_v1, _v2, item) => {
            return item.frozen.name;
          },
        },
        {
          key: 'frozenId',
          label: 'ID',
          formatter: (_v1, _v2, item) => {
            return item.frozen.uid;
          },
        },
      ],
      currentPage: 1,
      perPage: 50,
    };
  },
  computed: {
    ...mapState(['frozen']),
    ...mapGetters('frozen', ['totalRelatedFrozens']),
  },
  methods: {
    frozenTypeDisplay(type) {
      return basicFrozenType(type);
    },
  },
};
</script>

<style scoped>
.objects-header {
  margin-top: 10px;
  margin-left: 10px;
}
</style>
